import { selectFields } from '#src/lib/contentful/selectors.mjs';

import styles from './CardImage.scss';

export function CardImage({ image }) {
  const { file: { url } = {} } = selectFields(image) || {};
  return !url ? null : <img src={url} className={styles.cardImage} />;
}
